<template lang="pug">
v-container(style="max-width:960px")
  v-row(align="center" v-if="!isMobileScreen")
    v-col(cols="12")
      .d-flex.align-center.justify-end
        yc-pagination-custom.ml-4.my-auto(v-model="currentPage" :parentPageSize.sync="pageSize" :count="totalCount" :text="$t('item_list')" @input="pageChanged")
        slot(name="actions")

  .yc-table
    v-data-table.mt-sm-4.pb-16(:headers="headers" :items="fundraisers" item-key="id" :items-per-page="pageSize" :loading="isLoading" hide-default-footer disable-sort)
      template(v-slot:no-data)
        .mt-16
          v-img.mx-auto(src="@/assets/images/icon_empty.png" width=80)
          .mt-2.p2.basic600--text {{ $t('no_list_available') }}
      template(#item.ranking="{ item }")
        div {{ item.ranking }}
      template(#item.name="{ item }")
        div.font-semibold {{ item.user.first_name }} {{ item.user.last_name }}
      template(#item.raised="{ item }")
        div {{ item.raised | displayPrice }}
      template(#item.percentage="{ item }")
        div {{ item.raised_percentage }}%

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
export default {
  name: 'FundraisersRanking',
  props: ['pid', 'isSelectionMode', 'confirmText', 'loading', 'campaign', 'span', 'dateRange'],
  components: {},
  data: () => ({
    isLoading: false,
    searchText: '',
    currentPage: 1,
    pageSize: 20,
    totalCount: 0,
    sortBy: '',
    fundraisers: [],
    headers: [
      {
        text: 'Ranking',
        value: 'ranking',
        enable: true,
        class: 'text-table-header'
      },
      {
        text: 'Name',
        value: 'name',
        enable: true,
        class: 'text-table-header'
      },
      {
        text: 'Total Raised',
        value: 'raised',
        enable: true,
        class: 'text-table-header'
      },
      {
        text: 'Unit',
        value: 'donation_unit',
        enable: true,
        class: 'text-table-header'
      },
      {
        text: 'Percentage',
        value: 'percentage',
        enable: true,
        class: 'text-table-header'
      }
    ],
    checkAll: false,
    showDeleteDialog: false,
    showAddDialog: false
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    }),
    isMobileScreen() {
      return this.$vuetify.breakpoint.xs
    }
  },
  watch: {
    pageSize() {
      this.fetchFundraisers(1)
    },
    campaign (val) {
      this.fetchFundraisers(1, val)
    }
  },
  created() {
    this.fetchFundraisers(1)
  },
  methods: {
    ...mapActions(['showMessage']),
    fetchFundraisers(page, campaignId) {
      this.isLoading = true
      const params = {
        page_size: this.pageSize,
        page,
        ordering: this.sortBy,
        campaign: campaignId || ''
      }
      this.$axios.get(`/donations/${this.company.slug}/fundraisers`, { params })
        .then(resp => {
            if (resp.data.results) {
              this.fundraisers = resp.data.results
              this.fundraisers.map((f, idx) => f.ranking = (idx + 1) + (page - 1) * this.pageSize)
            }
            this.totalCount = resp.data.count
          })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    pageChanged(num) {
      this.fetchFundraisers(num)
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
</style>
